import AppLayoutWrapper from 'Layout/AppLayout/components/AppLayoutWrapper';
import AppNavigation from 'Layout/AppLayout/components/AppNavigation/AppNavigation';
import { AppHeader } from 'Layout/AppLayout/style/AppHeader';
import { Outlet } from 'react-router-dom';
import { Box } from 'style-utils/components/Box';

const AppSecondaryLayout = () => {
  return (
    <AppLayoutWrapper bg="bgPrimary">
      <AppHeader role="heading" aria-level={1}>
        <AppNavigation />
      </AppHeader>
      <Box as="main" px="1.6rem">
        <Outlet />
      </Box>
    </AppLayoutWrapper>
  );
};
export default AppSecondaryLayout;
